// src/Pages/DrinksMenuPage.tsx
import React from 'react';
import HeroSectionV2 from '../../../components/HeroSectionV2';
import DrinksMenuComponent from '../../../components/DrinksMenuComponent';
import Billede1 from '../../../Images/Billede1.jpg';
import AdminBackBar from "../../../components/admin/AdminBackBar";

const DrinksMenuPage: React.FC = () => {
    return (
        <div>
            <HeroSectionV2
                titleEn="Drinks Menu"
                titleDa="Drinks Menu"
                descriptionEn="Manage your drinks"
                descriptionDa="Administrér drinks"
                imageSrc={Billede1}
            />
            <AdminBackBar
                title="Drinks"
                crumbs={[
                    { label: "Admin", to: "/admin" },
                    { label: "Drinks" } // current
                ]}
            />

            <section style={{ padding: '20px' }}>
                <DrinksMenuComponent />
            </section>
        </div>
    );
};

export default DrinksMenuPage;